import Component from './active-alerts.component';

export default Component;
